"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let SendMails = class SendMails extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    items;
    onItems(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("items");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedTemplate;
    templates;
    async $$load_templates() {
        return this.$fn.fetch('list_template')
            .then(data => _.filter(data, { template_type: 'mjml' }));
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['selectedTemplate', 'templates', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedTemplate: null,
                templates: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Send emails"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3968_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_register_3974_getActionArgs($event) {
        return {
            name: "resultLength",
            value: $event.data.response.data ? $event.data.response.data.length : 0,
        };
    }
    async act_1040167445267876_notification_3976_getActionArgs($event) {
        return {
            message: this.$fn.ngettext("One email has been successfully enqueued.", "${n} emails have been successfully enqueued.", $event.data.resultLength),
        };
    }
    async act_1040167445267876_notification_3976_getWhen($event) {
        return $event.data.resultLength > 0;
    }
    async act_1040167445267876_reloadSlickgrid_3978_getActionArgs($event) {
        return {
            grid: "all",
        };
    }
    async act_1040167445267876_closeComponent_3980_getActionArgs($event) {
        return {
            result: {
                close: true,
            },
        };
    }
    async act_1040167445267876_request_3972_getActionArgs($event) {
        return {
            operation: "create_job",
            data: _.chain(this.items)
                .filter(item => item.customer_email)
                .map(item => ({
                job_type: 'sendmail:dunning_letter',
                job_data: {
                    id: item.id,
                    template: this.selectedTemplate,
                    mail_to: item.customer_email
                }
            }))
                .value(),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3968 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3968_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3967 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3968,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3967],
        });
        const act_2248226175642056_closeComponent_3970 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3969 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3970,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3969],
        });
        const act_1040167445267876_register_3974 = new core_1.actions.RegisterAction({
            actionArgs: this.act_1040167445267876_register_3974_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_3973 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_register_3974,
            event: "success",
            displayName: "register",
        });
        const act_1040167445267876_notification_3976 = new core_1.actions.NotificationAction({
            actionArgs: this.act_1040167445267876_notification_3976_getActionArgs,
            when: this.act_1040167445267876_notification_3976_getWhen,
            events: [],
        });
        const evh_1040167445267876_success_3975 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_notification_3976,
            event: "success",
            displayName: "notification",
        });
        const act_1040167445267876_reloadSlickgrid_3978 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_3978_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_3977 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_3978,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_closeComponent_3980 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_3980_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_3979 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_3980,
            event: "success",
            displayName: "closeComponent",
        });
        const act_1040167445267876_request_3972 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_3972_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_3973, evh_1040167445267876_success_3975, evh_1040167445267876_success_3977, evh_1040167445267876_success_3979],
        });
        const evh_1040167445267876_submit_3971 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_3972,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_3971],
        });
        const act_1419464017721962_closeComponent_3982 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_3981 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_3982,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_3981],
        });
        return {
            act_7315092382398562_closeModal_3968,
            evh_7315092382398562_close_3967,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3970,
            evh_2248226175642056_close_3969,
            evh_2248226175642056_close,
            act_1040167445267876_register_3974,
            evh_1040167445267876_success_3973,
            act_1040167445267876_notification_3976,
            evh_1040167445267876_success_3975,
            act_1040167445267876_reloadSlickgrid_3978,
            evh_1040167445267876_success_3977,
            act_1040167445267876_closeComponent_3980,
            evh_1040167445267876_success_3979,
            act_1040167445267876_request_3972,
            evh_1040167445267876_submit_3971,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_3982,
            evh_1419464017721962_clickPreventStop_3981,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_request_3972,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        default: null,
    }),
    __metadata("design:type", typeof (_a = typeof list !== "undefined" && list) === "function" ? _a : Object)
], SendMails.prototype, "items", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('items'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], SendMails.prototype, "onItems", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "sm",
    }),
    __metadata("design:type", String)
], SendMails.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], SendMails.prototype, "onSize", null);
SendMails = __decorate([
    (0, vue_property_decorator_1.Component)()
], SendMails);
exports.default = SendMails;
vue_property_decorator_1.Vue.component("SendMails", SendMails);
